export default __webpack_public_path__ + "static/media/slack-square.0aa3fd4a.svg";